import {useCallback} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {scrollToComponent, postSubmit} from "@ui-seeker/utils";
import {useAppToast} from "@ui-seeker/app";

import { BACKEND_APIS } from "@constants";
import {adminProductReviewDetails, adminProductReviewDetailsData, adminProductReviewItemsData, adminProductReviewSkuMappingData, adminProductReviewTableData} from "../@signals";
import { commonFiltersValue } from "@signals";


export default function useAdminProductReviewList(rowData={}, date=null, siteID=null, productID=null, skuID=null) {
	const { showToast } = useAppToast()

	const handleClickNumItems = useCallback(() => {
		adminProductReviewItemsData.value = adminProductReviewDetailsData.value[date][siteID][productID].map(item => ({
			...rowData,
			...item
		}))
		batch(() => scrollToComponent('product-review-details-table'))

	}, [JSON.stringify(rowData)])

	const handleClickDetails = useCallback(() => batch(() => {
		adminProductReviewDetails.value = {
			...adminProductReviewDetailsData.value[date][siteID][productID][0],
			...rowData
		}
	}), [JSON.stringify(rowData)])

	const handleClickSkuMapping = useCallback(() =>  {
		showToast.promise(postSubmit(`${BACKEND_APIS.ADMIN}/product-review/raw-data`, {...commonFiltersValue.value, retailer: [], sku:[rowData.skuID]}).then(({ table, detail }) => {
			adminProductReviewSkuMappingData.value = table
		}).catch(() => {showToast.error()})
		.finally(() => scrollToComponent('product-review-sku-mapping-table')))
	}, [JSON.stringify(rowData)])

	const handleCloseTableNumItems = useCallback(() => {
		adminProductReviewItemsData.value = []
	}, [])

	const handleCloseSkuMappingTable = useCallback(() => batch(() => {
		adminProductReviewSkuMappingData.value = []
	}), [])

	return {
		isOpenDrawer: adminProductReviewDetails.value.id === rowData.id,
		isOpenNumItemsTable: adminProductReviewItemsData.value.length > 0 && adminProductReviewItemsData.value.map(item => item.productID).includes(productID),

		handleClickNumItems, handleClickDetails, handleCloseTableNumItems, handleCloseSkuMappingTable, handleClickSkuMapping
	}
}